// ============================================================================
// MO'S ALGORITHM - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'mo-algorithm',
  name: 'Mo\'s Algorithm',
  category: 'Data Structures',
  complexity: {
    time: 'O((N + Q) * √N)',
    space: 'O(N)'
  },
  description: 'An offline algorithm for answering range queries on arrays efficiently. It processes queries in a special order that minimizes the number of changes when moving between query ranges, using sqrt decomposition.'
};
